import React from 'react';
import ClaimLocationFormatter from './ClaimLocationFormatter';
import InvoicesFormatter from './InvoicesFormatter';
import OrdersFormatter from '../OrdersFormatter';
import RoutesFormatter from '../RoutesFormatter';
import TransportsFormatter from './TransportsFormatter';
import AddressFormatter from '@afosto/utils-react/formatters/AddressFormatter';
import ProductImageFormatter from '@afosto/utils-react/formatters/ProductImageFormatter';
import ProductSkuFormatter from '@afosto/utils-react/formatters/ProductSkuFormatter';
import ShipmentsFormatter from '@afosto/utils-react/formatters/ShipmentsFormatter';
import TransferFormatter from '@afosto/utils-react/formatters/TransferFormatter';

export const addressFormatter = cell => <AddressFormatter addressId={cell} />;

export const claimLocationFormatter = cell => <ClaimLocationFormatter claimId={cell} />;

export const ordersFormatter = cell => <OrdersFormatter orderIds={cell} />;

export const invoicesFormatter = cell => <InvoicesFormatter invoiceIds={cell} />;

export const shipmentsFormatter = cell => <ShipmentsFormatter shipmentIds={cell} />;

export const productImageFormatter = (cell, row) => <ProductImageFormatter sku={row?.sku} />;

export const productSkuFormatter = cell => <ProductSkuFormatter sku={cell} />;

export const routesFormatter = cell => <RoutesFormatter routeIds={cell} />;

export const targetFormatter = cell => <OrdersFormatter orderIds={cell ? [cell] : []} />;

export const transferFormatter = cell => <TransferFormatter transferId={cell} />;

export const transportsFormatter = (cell, row) => (
  <TransportsFormatter transfer={row?.transfer} claimId={row?.claimId} />
);
